import { render } from "./BaoCaoCongTacYTeTruongHoc.vue?vue&type=template&id=69465d23&ts=true"
import script from "./BaoCaoCongTacYTeTruongHoc.vue?vue&type=script&lang=ts"
export * from "./BaoCaoCongTacYTeTruongHoc.vue?vue&type=script&lang=ts"

import "./BaoCaoCongTacYTeTruongHoc.vue?vue&type=style&index=0&id=69465d23&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/CDC/BaoCao/CDC_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__